import { Controller } from "@hotwired/stimulus"
import { useClickOutside } from "stimulus-use"

export default class extends Controller {
    static targets = [
        "itemsForFilterNotification",
        "filterNotification",
        "dropdownMenu",
        "filterButtonWrapper",
        "dropdownContent",
    ]

    connect() {
        useClickOutside(this, {
            element: this.dropdownContentTarget,
        })

        this.changeFilterNotification()
        window.addEventListener("dropdown:closeAll", this.closeDropdown.bind(this))
    }

    clickOutside(event) {
        event.preventDefault()
        // If you click on an element that is part of the filter dropdown button
        // then you stop propagating the event instead of
        // activating every clickoutside (because you are clicking outside the other buttons too)
        if (this.filterButtonWrapperTarget.contains(event.target)) {
            event.stopPropagation()
        }
        this.closeDropdown()
    }

    disconnect() {
        window.removeEventListener("dropdown:closeAll", this.closeDropdown.bind(this))
    }

    toggleDropdown(event) {
        event.preventDefault()
        const clickedButton = event.currentTarget

        if (!this.dropdownMenuTarget.classList.contains("hidden")) {
            this.closeDropdown()
            return
        }

        window.dispatchEvent(new CustomEvent("dropdown:closeAll"))
        const isOpen = this.dropdownMenuTarget.classList.toggle("hidden")
        clickedButton.setAttribute("aria-expanded", !isOpen)
        clickedButton.classList.add("text-white", "bg-primary")
        clickedButton.classList.remove("bg-white")
        // Store reference to the active button for closeDropdown
        this.activeButton = clickedButton
    }

    closeDropdown() {
        this.dropdownMenuTarget.classList.add("hidden")

        if (this.activeButton) {
            this.activeButton.setAttribute("aria-expanded", false)
            this.activeButton.classList.add("bg-white")
            this.activeButton.classList.remove("text-white", "bg-primary")
        }
    }

    changeFilterNotification() {
        const itemsChecked = this.itemsForFilterNotificationTargets.filter((item) => item.checked)
        this.filterButtonWrapperTarget.classList.remove("hasFilter")

        if (itemsChecked.length > 0) {
            this.filterNotificationTarget.textContent = itemsChecked.length
            this.filterButtonWrapperTarget.classList.add("hasFilter")
        }
    }

    resetFilter(event) {
        event.preventDefault()

        const checkboxes = this.dropdownContentTarget.querySelectorAll("input[type='checkbox']")
        const radios = this.dropdownContentTarget.querySelectorAll("input[type='radio']")
        checkboxes.forEach((checkbox) => {
            checkbox.checked = false
        })
        radios.forEach((radio) => {
            radio.checked = false
        })
        if (radios.length > 0) {
            radios[0].checked = true // select the first radio
        }

        window.dispatchEvent(new CustomEvent("salary:toggleRange"))

        this.changeFilterNotification()
    }
}
